<template>
  <div style="ma-2 pa-2 grey lighten-5">
    <v-container class style="max-width:100%">
      <div class="ml-4">
        <router-link to="/appli_db">アプリデータベース一覧に戻る</router-link>
      </div>

      <v-row>
        <v-col cols="12" md="6">
          <v-card class="ma-1 pa-2" min-height="300">
            <appli-detail :item="item" />
            <div style='text-align:right'><v-btn @click="save" color="primary">保存</v-btn></div>
          </v-card>
          <v-card class="ma-1 pa-2">
            <Chart v-if="loaded" :chart-data="datacollection" :options="options"></Chart>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="ma-1 pa-4" min-height="200" :loading="!loaded">
            <v-container fluid v-if="!loaded">
              <v-row justify="center" align-content="center">
                <v-col cols="1" sm="1" md="1">
                  <v-progress-circular indeterminate color="red"></v-progress-circular>
                </v-col>
              </v-row>
            </v-container>

            <table style="width:90%">
              <tr>
                <td class="pa-2">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeText"
                        label="セールスランキングデータの取得範囲"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates"
                      range
                      locale="jp-ja"
                      :day-format="date => new Date(date).getDate()"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="selectDate()">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </td>
                <td width="120" class="pa-2">
                  <v-btn :href="csvDownload()" color="primary">CSVダウンロード</v-btn>
                </td>
              </tr>
            </table>

            <table class="sales_table">
              <tr>
                <th width="40%">日付</th>
                <th>最高順位</th>
              </tr>
              <tr v-for="(item ,index) in this.sales_data" :key="index">
                <td>{{item.label}}</td>
                <td>{{item.data}}</td>
              </tr>
            </table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>



<script>
// Ajax通信ライブラリ
import axios from "axios";

import Chart from "@/components/Chart";

import AppliDetail from "@/components/applimanage/AppliItemDetail";

import Vue from "vue";

import moment from "moment";

export default {
  components: {
    Chart,
    AppliDetail
  },

  computed: {
    dateRangeText() {
      var start = this.dates[0];
      var end = this.dates[1];

      if (start > end) {
        return end + " ~ " + start;
      }
      return start + " ~ " + end;
    }
  },

  data() {
    return {
      sales_data: [],
      dates: [
        moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      ],
      date: new Date().toISOString().substr(0, 10),

      menu: false,
      modal: false,
      menu2: false,

      item: [],
      sales: [],
      loaded: false,
      datacollection: {},
      options: {
        elements: {
          line: {
            fill: false
          }
        }
      }
    };
  },

  mounted() {
    this.fillData();
    this.appliData();
  },

  methods: {
    selectDate() {
      var start = this.dates[0];
      var end = this.dates[1];

      if (start > end) {
        this.dates[0] = end;
        this.dates[1] = start;
      }
      this.modal = false;

      this.sales_data = [];

      this.fillData();

      console.log(this.dates);
    },

    appliData() {
      axios
        .get(process.env.VUE_APP_APPLI_DATA, {
          params: { id: this.$route.params.id }
        })
        .then(response => {
          console.log(response.data[0]);
          this.item = response.data[0];
        });
    },

    save() {
      // console.log(this.item)
      // var editedItem = {
      //   app_id: 111,
      //   title: "wqewqewqe"
      // };

      axios
        .post(process.env.VUE_APP_APPLI_SAVE, {
          data: this.item
        })
        .then(response => {
          console.log(response);
          alert("更新しました！");
        });
    },

    csvDownload() {
      return (
        process.env.VUE_APP_CSV_DOWNLOAD +
        this.$route.params.id +
        "&start=" +
        this.dates[0] +
        "&end=" +
        this.dates[1] +
        "&type=csv"
      );
    },

    fillData() {
      // var url = "http://tool-test.matomeroyal.com/wp-json/appmedia/v1/manual_sales_ranking_data?id=" +
      //       this.$route.params.id +
      //       "&start="+this.dates[0]+"&end="+this.dates[1]+"&type=auto"

      //       console.log(url)

      axios
        .get(
          process.env.VUE_APP_SALES_LIST +
            this.$route.params.id +
            "&start=" +
            this.dates[0] +
            "&end=" +
            this.dates[1] +
            "&type=auto"
        )
        .then(
          function(response) {
            console.log(response.data.ranking);
            // this.datacollection = response.data.ranking;
            var labels = [];
            var data = [];

            Object.keys(response.data.ranking).forEach((key, index) => {
              labels.push(response.data.ranking[key].date);
              data.push(response.data.ranking[key].rank);

              var tmp_rank = "";
              if (response.data.ranking[key].rank == 201) {
                tmp_rank = "200位圏外";
              } else {
                tmp_rank = response.data.ranking[key].rank;
              }

              this.sales_data.push({
                label: response.data.ranking[key].date,
                data: tmp_rank
              });

              console.log(index, response.data.ranking[key]);
            });

            // this.sales_data = this.sales_data.reverse();

            this.datacollection = {
              labels: labels,
              datasets: [
                {
                  label: "セールスランキング",
                  type: "line",
                  data: data,
                  borderColor: "rgba(75,192,192,1)",
                  backgroundColor: "rgba(0,0,0,0)",
                  fill: true,
                  borderWidth: 1
                }
              ]
            };

            this.options = {
              scales: {
                yAxes: [
                  {
                    ticks: {
                      reverse: true,
                      min: 1,
                      max: 200,
                      stepSize: 10
                    }
                  }
                ]
              }
            };

            Vue.set(this.datacollection, "datacollection", this.options);
          }.bind(this)
        )
        .catch(error => {
          console.error(error);
        })
        .finally(() => (this.loaded = true));
    }
  },

  created() {
    console.log(`${this.$route.params.id}`);
    //アプリ詳細は常に最新データを取得する
  }
};
</script>

<style>
table.sales_table {
  width: 96%;
  margin: 6px;
}
table.sales_table td {
  border: 1px solid #ddd;
  text-align: center;
}
</style>